import React from 'react';

const ManageProfileIcon = () => (
    <svg
        height={22}
        width={22}
        clipRule="evenodd"
        fillRule="evenodd"
        y="0px"
        x="0px"
        viewBox="0 0 427 427"
        xmlSpace="preserve"
        imageRendering="optimizeQuality"
        shapeRendering="geometricPrecision"
        textRendering="geometricPrecision"
    >
        <path
            d="M214 0c118 0 213 96 213 214s-95 213-213 213S0 332 0 214 96 0 214 0zm0 93c48 0 88 39 88 88 0 30-15 57-38 73 39 15 71 46 91 84 29-33 47-77 47-124 0-104-84-189-188-189S25 110 25 214c0 47 18 91 47 124 21-38 52-69 91-84-23-16-38-43-38-73 0-48 40-88 89-88zm0 25c-35 0-63 28-63 63s28 63 63 63 63-28 63-63-28-63-63-63zm122 238c-23-47-67-86-122-86-56 0-99 39-123 86 33 29 76 46 123 46s89-17 122-46z"
            fill="#000"
            fillRule="nonzero"
        />
    </svg>
);

export default ManageProfileIcon;
